module.exports = __webpack_public_path__ + "static/media/joundmob.79e15940.jpg";